import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { BasicLayout } from "src/components/layouts/layout"
import { constantRouterMap } from './router.config'

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location: any, onResolve: any, onReject: any)
// {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
//   return originalPush.call(this, location)
// }

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: constantRouterMap
});

export default router;
